/*  ========================================================================
    # Sections - Calendar - List Entry
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';

const CalendarListEntry = ({
  url,
  image,
  title,
  excerpt,
  start_date,
  end_date,
  start_time,
  end_time,
  place,
  number_of_participants,
  only_members
}) => {
  const formatDate = date => {
    return Intl.DateTimeFormat('de-DE', { dateStyle: 'medium' }).format(new Date(date));
  };

  return (
    <div className='s-calendar__list-entry'>
      <a className='s-calendar__list-entry-image' href={url}>
        <figure>
          <img src={image} />
          {only_members && <figcaption>für Mitglieder</figcaption>}
        </figure>
      </a>
      <div className='s-calendar__list-entry-content'>
        <span className='s-calendar__list-entry-date'>
          {formatDate(start_date)}
          {end_date && <> - {formatDate(end_date)}</>}
        </span>
        <a style={{ alignSelf: 'flex-start', background: 'none' }} href={url}>
          <h4 className='s-calendar__list-entry-title'>{title}</h4>
        </a>
        <p className='s-calendar__list-entry-excerpt'>{excerpt}</p>
        <div className='s-calendar__list-entry-bottom'>
          <div className='s-calendar__list-entry-details'>
            <span>{place}</span>
            <span>
              von {start_time} - {end_time}
            </span>
            <span>{number_of_participants} Teilnehmer</span>
          </div>
          <a className='button button--link button--small' href={url}>
            Mehr erfahren
          </a>
        </div>
      </div>
    </div>
  );
};

CalendarListEntry.propTypes = {
  url: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  excerpt: PropTypes.string,
  start_date: PropTypes.string,
  end_date: PropTypes.string,
  start_time: PropTypes.string,
  end_time: PropTypes.string,
  place: PropTypes.string,
  number_of_participants: PropTypes.string,
  only_members: PropTypes.bool
};

export default CalendarListEntry;
